import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppRootState} from '../appStore';
import {Board, BoardView} from 'models/board';
import {BoardFormModel} from 'models/board/boardDynamicForm.model';
export interface boardState {
    boardsRedux: Board[];
    selectedBoardRedux?: Board | null;
    boardViewsRedux: BoardView[];
    selectedBoardViewRedux: BoardView | null;
    search?: string;
    selectedBoardSlug?: string;
    selectDefaultBoardForm?: BoardFormModel;
}

let initialState: boardState = {
    boardsRedux: [],
    selectedBoardRedux: null,
    boardViewsRedux: [],
    selectedBoardViewRedux: null,
    search: undefined,
};

export const boardSlice = createSlice({
    name: 'boards',
    initialState,
    reducers: {
        addBoard: (state, action: PayloadAction<Board[]>) => {
            state.boardsRedux = action.payload;
        },
        setBoardSearch: (state, action: PayloadAction<string | undefined>) => {
            state.search = action.payload;
        },

        setSelectedBoard: (state, action: PayloadAction<Board | null>) => {
            state.selectedBoardRedux = action.payload;
        },
        removeBoard: (state, action: PayloadAction<string>) => {
            state.boardsRedux = state.boardsRedux.filter(board => board.id !== action.payload);
        },
        setDefaultBoardForm: (state, action: PayloadAction<BoardFormModel>) => {
            state.selectDefaultBoardForm = action.payload;
        },
        setBoardViews: (state, action: PayloadAction<BoardView[]>) => {
            state.boardViewsRedux = action.payload;
        },
        addBoardView: (state, action: PayloadAction<BoardView>) => {
            state.boardViewsRedux.push(action.payload);
        },
        setSelectedBoardView: (state, action: PayloadAction<BoardView | null>) => {
            state.selectedBoardViewRedux = action.payload;
        },
        removeBoardView: (state, action: PayloadAction<string>) => {
            state.boardViewsRedux = state.boardViewsRedux.filter(boardView => boardView.id !== action.payload);
        },
    },
});

export const {
    setBoardSearch,
    removeBoard,
    addBoard,
    setDefaultBoardForm,
    setSelectedBoard,
    setBoardViews,
    setSelectedBoardView,
    addBoardView,
    removeBoardView,
} = boardSlice.actions;

export const boardSliceReducer = boardSlice.reducer;
export const boardSelector = (rootState: AppRootState): boardState => rootState.boards;
